import type { UnsleepingId } from '@somnhold/content';
import type { UnRender } from './ctx.ts';
import { bruniFx } from './bruni.ts';
import { corvinFx } from './corvin.ts';
import { kaelaFx } from './kaela.ts';
import { lucanFx } from './lucan.ts';
import { eddaFx } from './edda.ts';
import { velaFx } from './vela.ts';
import { anselFx } from './ansel.ts';
import { ragnaFx } from './ragna.ts';

export type { UnCtx, UnLook, UnRender } from './ctx.ts';
export { felled, moment, presence, vanished } from './common.ts';
export { UnsleepingFx } from './fx.ts';

/** Every Unsleeping's own effects, by id. */
export const UN_RENDER: Record<UnsleepingId, UnRender> = {
  corvin: corvinFx,
  kaela: kaelaFx,
  lucan: lucanFx,
  edda: eddaFx,
  vela: velaFx,
  ansel: anselFx,
  bruni: bruniFx,
  ragna: ragnaFx,
};
